// @charset "utf-8"
/* eslint-disable no-undef */
/* eslint-disable no-new */
export function showTradeDateDialog (event, maxDate, minDate, options) {
    let theEvent = window.event || event
    let domEl = theEvent.target || theEvent.srcElement || theEvent.toElement
    let settings = {
        el: domEl,
        maxDate: maxDate,
        minDate: minDate,
        startDate: '%y-$M-%d',
        isShowClear: false,
        readOnly: true,
        onpicked: function (val) {
            /* fire v-model event begin */
            /* TODO fireEvent for IE */
            let inputEvent = document.createEvent('HTMLEvents')
            inputEvent.initEvent('input', false, true)
            domEl.dispatchEvent(inputEvent)
            /* fire v-model event end */
        }
    }

    new WdatePicker(Object.assign(settings, options))
}



// WEBPACK FOOTER //
// ./src/lib/wDatePicker.js